module.exports = __webpack_public_path__ + "images/scroll-icon.a49355ea.svg";